<template>
  <header class="mt-cabecera" :class="{ 'mt-cabecera--sombra': conSombra }">
    <div class="mt-contenedor mt-cabecera__fila">
      <MinotariaMarca />
      <nav class="mt-cabecera__nav" aria-label="Secciones">
        <a v-if="enInicio" href="#como-funciona">Cómo funciona</a>
        <a v-if="enInicio" href="#tramites">Trámites</a>
        <a v-if="enInicio" href="#preguntas">Preguntas</a>
        <a v-if="enInicio" href="#notarias">Para notarías</a>
        <NuxtLink v-if="!enInicio" :to="ruta('/')">Inicio</NuxtLink>
        <NuxtLink v-if="blogActivo" :to="ruta('/blog')">Blog</NuxtLink>
      </nav>
      <NuxtLink v-if="!enEncargo" :to="ruta('/encargo-online')" class="mt-boton mt-boton--acento mt-cabecera__cta">
        Empezar encargo
      </NuxtLink>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount, ref } from 'vue'
import MinotariaMarca from './MinotariaMarca.vue'
import { useMinotariaBlog } from '../../composables/useMinotariaBlog'

const route = useRouter().currentRoute
const nombre = computed(() => String(route.value.name || '').replace(/^lang-/, ''))
const enInicio = computed(() => nombre.value === 'index')
const enEncargo = computed(() => nombre.value === 'encargo-online')
const { activo: blogActivo } = useMinotariaBlog()
const ruta = (p: string) => (route.value.params.lang ? `/${route.value.params.lang}` : '') + p

// La sombra aparece al bajar: arriba la cabecera se funde con la portada
const conSombra = ref(false)
const alDesplazar = () => { conSombra.value = window.scrollY > 8 }
onMounted(() => { alDesplazar(); window.addEventListener('scroll', alDesplazar, { passive: true }) })
onBeforeUnmount(() => window.removeEventListener('scroll', alDesplazar))
</script>
